module.exports = __webpack_public_path__ + "img/QR.0.1.0_202304111702.png";